// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#chat .loader{display:flex;justify-content:center}", "",{"version":3,"sources":["webpack://./resources/js/components/molecules/ChatMessageList/style.scss"],"names":[],"mappings":"AAAA,cAAc,YAAY,CAAC,sBAAsB","sourcesContent":["#chat .loader{display:flex;justify-content:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
